module.exports = __webpack_public_path__ + "static/img/club.7b6a8a95.svg";